// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageMagnifier_magnifier__ozLUN {
  --img-src: "";
  --magnifier-width: 0;
  --magnifier-height: 0;
  --zoom-level: 0;
  --cursor-x: 0;
  --cursor-y: 0;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ImageMagnifier_magnifier__img__U3GAr {
  max-height: 100%;
  cursor: crosshair;
}

.ImageMagnifier_magnifier__zoomed-div__-sOy- {
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: calc(var(--magnifier-width) * 1.1);
  width: 60rem;
  z-index: var(--z-magnifier);
  border: 0.1rem solid var(--black-eighty-opacity);
  background-image: var(--img-src);
  background-repeat: no-repeat;
  background-size: calc(var(--magnifier-width) * var(--zoom-level))
    calc(var(--magnifier-height) * var(--zoom-level));
  background-position: var(--cursor-x) var(--cursor-y);
}

.ImageMagnifier_magnifier__zoomed-div--hidden__Vqqib {
  display: none;
}

@media screen and (max-width: 1024px) {
  .ImageMagnifier_magnifier__zoomed-div__-sOy- {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .ImageMagnifier_magnifier__zoomed-div__-sOy- {
    width: 50rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/ImageMagnifier/ImageMagnifier.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,yCAAyC;EACzC,YAAY;EACZ,2BAA2B;EAC3B,gDAAgD;EAChD,gCAAgC;EAChC,4BAA4B;EAC5B;qDACmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".magnifier {\n  --img-src: \"\";\n  --magnifier-width: 0;\n  --magnifier-height: 0;\n  --zoom-level: 0;\n  --cursor-x: 0;\n  --cursor-y: 0;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.magnifier__img {\n  max-height: 100%;\n  cursor: crosshair;\n}\n\n.magnifier__zoomed-div {\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: calc(var(--magnifier-width) * 1.1);\n  width: 60rem;\n  z-index: var(--z-magnifier);\n  border: 0.1rem solid var(--black-eighty-opacity);\n  background-image: var(--img-src);\n  background-repeat: no-repeat;\n  background-size: calc(var(--magnifier-width) * var(--zoom-level))\n    calc(var(--magnifier-height) * var(--zoom-level));\n  background-position: var(--cursor-x) var(--cursor-y);\n}\n\n.magnifier__zoomed-div--hidden {\n  display: none;\n}\n\n@media screen and (max-width: 1024px) {\n  .magnifier__zoomed-div {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .magnifier__zoomed-div {\n    width: 50rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"magnifier": `ImageMagnifier_magnifier__ozLUN`,
	"magnifier__img": `ImageMagnifier_magnifier__img__U3GAr`,
	"magnifier__zoomed-div": `ImageMagnifier_magnifier__zoomed-div__-sOy-`,
	"magnifier__zoomed-div--hidden": `ImageMagnifier_magnifier__zoomed-div--hidden__Vqqib`
};
export default ___CSS_LOADER_EXPORT___;
